import UnimedWelcomes from "../../../assets/svgs/UnimedWelcomes";
import PageTitle from "../../../components/Accessibility/PageTitle";
import { UnimedAcolheOptionsProps } from "../../../interfaces/props/SaudeBemEstar/UnimedAcolhe/UnimedAcolheProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import './styles.css'
import UnimedAcolheButtons from "./UnimedAcolheButtons";

function UnimedAcolheOptions(props: UnimedAcolheOptionsProps){
    const accessibility = useAccessibility();
    return (
        <div className="unimed-acolhe-holder">
            <PageTitle text="Unimed Acolhe" />
            <UnimedWelcomes/>
            <div className="unimed-acolhe-body">
                <UnimedAcolheButtons menu={props.menus}/>
            </div>
        </div>
    )
}

export default UnimedAcolheOptions;